import React from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import SglContext from '../SglContext';
import ReactModal from "react-modal";
import "./checkout.css";
import ManageCards from "../common/ManageCards";

import indicator_icon from "../images/Indicator.gif";

import visa_image from "../images/paymentlogos/visa.png";
import mastercard_image from "../images/paymentlogos/mastercard.png";
import discover_image from "../images/paymentlogos/discover.png";
import americanexpress_image from "../images/paymentlogos/americanexpress.png";
import AddBankModal from "../common/AddBankModal";

// const sgl_webservice_checkout = Sgl.sglApiUrl+'/iphonev2/checkoutv2/';


var AddModal = ReactModal;

/* CheckoutPayment Component 
-------------------------------------------------*/
class CheckoutPayment extends React.Component {
    get sgl_webservice_checkout() {
        return this.context.sglApiUrl + '/iphonev2/checkoutv2/';
    }

    constructor(props) {
        super(props);

        this.openSelectCardModal = this.openSelectCardModal.bind(this);
        this.closeSelectCardModal = this.closeSelectCardModal.bind(this);
        this.closeAddBankModal = this.closeAddBankModal.bind(this);

        this.openViewRefundPolicyModal = this.openViewRefundPolicyModal.bind(this);
        this.closeViewRefundPolicyModal = this.closeViewRefundPolicyModal.bind(this);
        
        this.state = {
            selected_payment_method: -1,
            selected_payment_method_type: '',
            is_open_manage_card_modal: false,
            is_open_add_bank_modal: false,
            is_open_add_card_modal: false,
            
            deposit_cvv: "",
                        
            
        };
        
    }

    componentWillMount() {
        
    }
    /////////////// manage cards functions ////////////////////

    onDepositMethodSelect(e) {
        if (e.target.value === 'ManageCards'){
          this.openSelectCardModal();
          this.setState({
            selected_payment_method: '-1',
          });
        } else if (e.target.value === 'AddBankAccount'){
            this.openAddBankModal();
            this.setState({
              selected_payment_method: '-1',
            });
          }
         else {
            // Determine if it's a card or a bank account
            const selectedOption = e.target.selectedOptions[0]; // Get selected <option>
            const type = selectedOption.getAttribute("data-type"); // Retrieve data-type
            this.setState({
            selected_payment_method_type: type,
            });

          this.setState({
            selected_payment_method: e.target.value,
          });
          
        }
      }

      openSelectCardModal() {
        this.setState({
          is_open_manage_card_modal: true,
        });
      }
  
      closeSelectCardModal() {
        this.setState({
          is_open_manage_card_modal: false,
        });
        
      }

      openAddBankModal() {
        this.setState({
          is_open_add_bank_modal: true,
        });
      }
  
      closeAddBankModal() {
        this.props.getPaymentMethods();
        this.setState({
            is_open_add_bank_modal: false,
        });
        
      }
  
    /////////////// end manage cards functions ////////////////////

    updateDepositCvv(evt){
        const re = /^[0-9\b]+$/;
        if (evt.target.value === '' || re.test(evt.target.value)) {
        // if (evt.target.value != '' && !Number(evt.target.value)) {

            this.setState({
                deposit_cvv: evt.target.value
            });
        }
    }

    ///////////// refund policy functions /////////////////////////
    openViewRefundPolicyModal() {
        this.setState({
          is_open_view_policy_modal: true,
        });
    }
  
    closeViewRefundPolicyModal() {
        this.setState({
          is_open_view_policy_modal: false,
        });
        
    }
    getRefundPolicy(){
        if (this.props.smc_payment.refund_policy === ''){
            return this.props.smc_payment.name + ' has not provided a refund policy at this time.  Please refer to the Prize List or other event documentation for the refund policy in effect for this transaction.'
        } else {
            return this.props.smc_payment.refund_policy;
        }
    }
    ///////////// end refund policy functions /////////////////////////


    updateSelectAllEntries(e){
        var checked = e.target.checked;
        if (checked){
            // this.props.selected_entries = this.props.checkout_list;
            this.props.updateSelectedEntries(this.props.checkout_list);
            // this.setState({ selected_entries: this.props.checkout_list });

        } else {
            // this.setState({ selected_entries: [] });
            // this.props.selected_entries = [];
            this.props.updateSelectedEntries([]);
        }

        
    }
    updateSelectedEntriesList(e, entry_id) {
        var selected_entries_list = [...this.props.selected_entries];

        var checked = e.target.checked;
        if (checked){
            var entry = this.props.checkout_list.find(c => (c.entry_id === entry_id));
            selected_entries_list.push(entry);
        } else {
            selected_entries_list = selected_entries_list.filter(c => (c.entry_id !== entry_id));
        }
        this.props.updateSelectedEntries(selected_entries_list);
        
      }
      getCheckedValue(entry_id){
        const entry_exists = this.props.selected_entries.find(c => c.entry_id === entry_id);
        if(entry_exists){
            return true;
        } else {
            return false;
        }

      }
      getAmountSum(field){
        let sum = this.props.selected_entries.reduce(function(prev, current) {
            return prev + +current[field]
          }, 0);

          if ( field == 'ach_service_fee_amount' && sum > this.props.ach_service_fee_cap) {
            sum = 5;
          }
          return sum;
      }
      getSubtotal(){
        var sub_total = this.getAmountSum('class_amount') + this.getAmountSum('misc_amount') + this.getAmountSum('tax');
        return sub_total;
      }
      getTotalAmount(){
        var total = this.getAmountSum('balance') + ((this.state.selected_payment_method_type == 'bank') ? this.getAmountSum('ach_service_fee_amount') : this.getAmountSum('cc_service_fee_amount'));
        return total;
        
      }

      //////////// saving data functions ///////////////
      saveCheckoutPayments = () => (e) => {
        document.getElementById('payment_warning').style.display = "none";
        document.getElementById('submit-please-wait').style.display = "block";
        document.getElementById('submit-payment-button').style.display = "none";
        
        if (this.props.selected_entries.length > 0){
            if(this.props.check_payment_method_info && this.state.selected_payment_method_type != 'bank' ){
                this.checkPaymentMethodApiCall(this.state.selected_payment_method);
            } else {
                this.submitPaymentApiCall(this.state.selected_payment_method); 
            }
        } else {
            var error_msg = 'You must select at least one entry with outstanding balance.'
            this.setState({payment_error_msg: error_msg}); 
            document.getElementById('payment_warning').style.display = "block";
            document.getElementById('submit-please-wait').style.display = "none";
            document.getElementById('submit-payment-button').style.display = "block";
        }
      }

      checkPaymentMethodApiCall(payment_method_id) {
        axios.post(this.sgl_webservice_checkout+'CheckPaymentMethod', null, { params: {
              payment_method_id : payment_method_id,
              customer_id: this.context.company_id,
              cvv: this.state.deposit_cvv,
              team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
              
          }
        })
        .then(results => {
  
          if(results.data.result) {
            this.submitPaymentApiCall(payment_method_id);  
          } else {
            this.setState({payment_error_msg: results.data.error}); 
            document.getElementById('payment_warning').style.display = "block";
            document.getElementById('submit-please-wait').style.display = "none";
            document.getElementById('submit-payment-button').style.display = "block";
          }
        });
      }

      onSelectedPaymentMethodType(e) {
        this.setState({
          selected_payment_method_type: e.target.value,
          selected_payment_method: '-1',
        });
      }

      submitPaymentApiCall(payment_method_id) {

        var entry_ids_list = this.props.selected_entries.map(s=>s.entry_id);

        var entry_balances_list = this.props.selected_entries.map(s=>
            ({entry_id: s.entry_id, entry_balance: s.balance, entry_CCServiceFee: s.cc_service_fee_amount, entry_ACHServiceFee: s.ach_service_fee_amount})
            
        );

        axios.post(this.sgl_webservice_checkout+'SubmitPayment', null, { params: {
            txtPaymentMethods : payment_method_id,
            selected_payment_method_type : this.state.selected_payment_method_type,
            hdnTotalAmount : this.getTotalAmount(),
            hdnDescription: this.props.payment_description,
            hdnEntryIDs: entry_ids_list.join(':'),
            hdnEntryBalances: JSON.stringify(entry_balances_list),
            // applycreditbalance : 'no',
            txtCVV: this.state.deposit_cvv,
            show_id: this.props.current_show,
            customer_id: this.context.company_id,
            sgl_plugin: true,
            team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
          }
        })
        .then(results => {
            document.getElementById('submit-please-wait').style.display = "none";
            document.getElementById('submit-payment-button').style.display = "block";
            this.props.showPaymentResults(results.data);
            this.setState({selected_payment_method: -1, deposit_cvv: ''}); 
        });
      }
        //////////// end saving data functions ///////////////

        


      format_currancy(amount){
        if(amount === 0){
          return '$0.00';
        }
        if(amount === undefined || amount === ''){
          return '';
        }
        // return '$'+(amount && amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        return '$'+(amount && Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  
      }

      setArrow(expanded){
        let className = 'direction';
  
        className += (expanded) ? ' asc' : ' desc';
        return className;
      }

      handleExpandClick = (entry) => (e) => {
        
            var expanded = entry.expanded?false:true;

            var entries_list = this.props.checkout_list;
            entries_list = entries_list.map(el => (el.entry_id === entry.entry_id ? { ...el, expanded } : el)) ;
            this.props.updateCheckoutList(entries_list);
    
      }

    // onShowChange2(e) {
    //     if (e.target.value !== this.state.checkout.include_all_shows) {
    //       this.props.onShowChange (e.target.value);
    //     }
    //     this.setCheckout( e.target.value );
    //  }

    

    render() {
        if(!this.props.can_checkout){
            return <div className='required'>You cannot checkout entries for this team.</div>
        }

        return (
          <div className="checkout_page">
            <div id=''>
                <div> 
                    <table  style={{width: "100%"}} className="table table-striped table-hover">
                        <tbody>
                            <tr className="sgl-primary-header">
                                <th ><input type="checkbox" className="centerCheckBox" name="selectAllEntries" id={"all_entries"}  checked={(this.props.checkout_list.length === this.props.selected_entries.length)} onChange={e => this.updateSelectAllEntries(e)}/></th>
                                <th className="display_on_desktop">Entry</th>
                                <th className="display_on_desktop">Horse</th>
                                <th className="display_on_desktop">Riders</th>
                                <th className="display_on_desktop">Owner</th>
                                <th className="display_on_mobile">Entries</th>
                                <th className=" right-align">Balance</th>
                                <th></th>
                            </tr>
                        {/* </thead> */}
                        {/* <tbody> */}
                            { (this.props.checkout_list.length > 0) ?
                                this.props.checkout_list.map((data, index) => {
                                // var EntityReservationBooking = data.EntityReservationBookings?data.EntityReservationBookings[0]:{};
                                return [
                                    // <>
                                    <tr>
                                        <td className="centerCheckBox"><input type="checkbox" name="selectEntry" id={"entry_"+data.entry_id} checked={this.getCheckedValue(data.entry_id)} onChange={e => this.updateSelectedEntriesList(e, data.entry_id)}/></td>
                                        <td className="display_on_mobile mbl_custom_row new-line">
                                            <p className="table_row_p">
                                            <span><strong>Entry:</strong><strong><Link to={'/entries/detail?eid='+data.entry_id+'&sid='+data.show_id}>{data.number}</Link></strong></span>
                                            <br></br>
                                            <span><strong>Horse:</strong> <Link to={'/entries/detail?eid='+data.entry_id+'&sid='+data.show_id}>{data.horse?data.horse:'N/A'} {data.trainer_account?data.app_trainer_account_text:''}</Link></span>
                                            <br></br>
                                            <span><strong>Riders:</strong> {data.rider_list} <span className='show_name'>{this.props.include_all_shows?'\n Show: '+data.show_name:''}</span></span>
                                            <br></br>
                                            <span><strong>Owner:</strong> <Link to={'/people/detail?pid='+data.entryowner_id+'&sid='+data.show_id}>{data.owner}</Link></span>
                                            </p>
                                        </td>
                                        <td className="centerCheckBox display_on_desktop"><strong><Link to={'/entries/detail?eid='+data.entry_id+'&sid='+data.show_id}>{data.number}</Link></strong></td>
                                        <td className="centerCheckBox display_on_desktop"><Link to={'/entries/detail?eid='+data.entry_id+'&sid='+data.show_id}>{data.horse?data.horse:'N/A'} {data.trainer_account?data.app_trainer_account_text:''}</Link></td>
                                        <td className="centerCheckBox display_on_desktop new-line">{data.rider_list} {this.props.include_all_shows} <span className='show_name'>{this.props.include_all_shows?'\n Show: '+data.show_name:''}</span></td>
                                        <td className="centerCheckBox display_on_desktop"><Link to={'/people/detail?pid='+data.entryowner_id+'&sid='+data.show_id}>{data.owner}</Link></td>
                                        <td className="centerCheckBox right-align">{this.format_currancy(data.balance)}</td>
                                        <td className="centerCheckBox center-align" onClick={ this.handleExpandClick(data)}>
                                            <div className='ring-arrow sgl-arrow' >
                                                <span className={this.setArrow(data.expanded)}></span>
                                            </div>
                                        </td>
                                    </tr>,
                                        <tr className={data.expanded?'':'display_none'}>
                                            <td colSpan="4" className="display_on_desktop"></td>
                                            <td className="display_on_mobile"></td>
                                            <td className="right-align">
                                                    
                                                 <p className="entry-detail-p">
                                                    <span>Class Fee:</span>
                                                    <br></br>
                                                    <span>Misc. Fee:</span>
                                                    <br></br>
                                                    <span>Tax:</span>
                                                    <br></br>
                                                    <span><strong>Subtotal:</strong></span>
                                                    <br></br>
                                                    <span>Payments:</span>
                                                    <br></br>
                                                    <span><strong>Balance:</strong></span>
                                                </p>
                                            </td>
                                            <td  className="right-align">
                                                <p className="entry-detail-p">
                                                    <span>{this.format_currancy(data.class_amount)}</span>
                                                    <br></br>
                                                    <span>{this.format_currancy(data.misc_amount)}</span>
                                                    <br></br>
                                                    <span>{this.format_currancy(data.tax)}</span>
                                                    <br></br>
                                                    <span>{this.format_currancy(data.class_amount+data.misc_amount+Number(data.tax))}</span>
                                                    <br></br>
                                                    <span>{this.format_currancy(data.total_paid)}</span>
                                                    <br></br>
                                                    <span>{this.format_currancy(data.balance)}</span>
                                                </p>
                                                
                                            </td>
                                            <td></td>
                                        </tr>
                                ]
                                })
                            :
                                <tr>
                                    <td colSpan="7">You have no entries with outstanding balance.</td>                                        
                                </tr>
                            }
                            <tr>
                                <td colSpan="7">
                                    <label className="sgl-label-border sgl-add_entry"><h2>Summary of Payable Amount</h2></label>
                                </td>                                         

                            </tr>
                            <tr>
                                <td colSpan="4" className="display_on_desktop"></td>
                                <td className="display_on_mobile"></td>
                                <td className="right-align"> Class Fees: </td>
                                <td  className="right-align">{this.format_currancy(this.getAmountSum('class_amount'))} </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan="4" className="display_on_desktop"></td>
                                <td className="display_on_mobile"></td>
                                <td className="right-align"> Misc. Fees: </td>
                                <td  className="right-align">{this.format_currancy(this.getAmountSum('misc_amount'))} </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan="4" className="display_on_desktop"></td>
                                <td className="display_on_mobile"></td>
                                <td className="right-align"> Tax: </td>
                                <td  className="right-align">{this.format_currancy(this.getAmountSum('tax'))} </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan="4" className="display_on_desktop"></td>
                                <td className="display_on_mobile"></td>
                                <td className="right-align"><b> Subtotal: </b></td>
                                <td  className="right-align"><b>{this.format_currancy(this.getSubtotal())} </b></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan="4" className="display_on_desktop"></td>
                                <td className="display_on_mobile"></td>
                                <td className="right-align"> Payments: </td>
                                <td  className="right-align">{this.format_currancy(this.getAmountSum('total_paid'))} </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan="4" className="display_on_desktop"></td>
                                <td className="display_on_mobile"></td>
                                <td className="right-align"><b> Balance: </b></td>
                                <td  className="right-align"><b>{this.format_currancy(this.getAmountSum('balance'))} </b></td>
                                <td></td>
                            </tr>
                        
                        </tbody>
                    </table>
                </div>
            
                <div>
                    <label className="sgl-label-border sgl-add_entry"><h2>Payment Method Info</h2></label>
                    <p>
                        {/* <td colspan='2'> */}
                            <b>NOTE: Please select a payment method to be used to pay for entry/entries selected above. You will be charged immediately for the full balance due on each selected entry. If you have questions about the detail of the charges please click the "i" button next to the entry or click the entry number for full account details.  You may also contact the show office.</b>
                        {/* </td> */}
                    </p>
                    <div className='entry_people_li'>
                        <div style={{clear: "both"}}></div>
                        <div style={{display:"inline-block",width: '50%'}} id="selected_payment_method_card" className='sgl-primary-header className-details, primary-header className-details-header add_entry_options'>
                            <input disabled={!this.props.can_checkout} checked={this.state.selected_payment_method_type === 'card' || !this.props.ach_enabled} style={{float: "left"}} type="radio" name='selected_payment_method_type' id='selected_payment_method_type_card' value='card' onChange={(e) => {this.onSelectedPaymentMethodType(e)}}/>
                            <label for="selected_payment_method_type_card" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Credit Card</label>
                        </div>
                    </div>
                    {
                    (this.state.selected_payment_method_type == 'card' || !this.props.ach_enabled)?
                    <>
                    <table className="table payment_table">
                        <tbody>
                        <tr className='bold'>
                                <td> We Accept </td>
                                <td>
                                    {this.props.smc_payment.pmnt_visa &&
                                        <img className="payment_cards_icon" src={visa_image} />
                                    }
                                    {this.props.smc_payment.pmnt_mastercard &&
                                        <img className="payment_cards_icon" src={mastercard_image} />
                                    }
                                    {this.props.smc_payment.pmnt_discover &&
                                        <img className="payment_cards_icon" src={discover_image} />
                                    }
                                    {this.props.smc_payment.pmnt_american_express &&
                                        <img className="payment_cards_icon" src={americanexpress_image} />
                                    }
                                
                                </td>
                        </tr>
                        <tr>
                            <td className='bold'> Credit Cards </td>
                            <td>
                                <select id="credit_card" className="input-height select-width" value={this.state.selected_payment_method} onChange={(e) => this.onDepositMethodSelect(e)}>
                                    <option value="-1">Select Credit Card...</option>
                                    {
                                        this.props.payment_methods.map((payment_method,index) => {
                                        return (
                                            <option value={`${payment_method.sgl_id}`} key={payment_method.sgl_id} data-type="card">
                                                {payment_method.label}
                                            </option>
                                        )
                                        })
                                    }
                                    <option value='ManageCards'>Manage Credit Cards</option>
                                </select>
                            </td>
                        </tr>
                        <tr>

                            <td className='bold'> CVV </td>
                            <td>
                                <input className="input-height input-width" type="text" 
                                    name="deposit_CVV" id='deposit_CVV' 
                                    maxLength="4"
                                    value={this.state.deposit_cvv} 
                                    onChange={evt => this.updateDepositCvv(evt)}/>
                            </td>
                        </tr>
                        <tr>

                            <td className='bold'> Amount </td>
                            <td>{this.format_currancy(this.getAmountSum('balance'))} </td>
                        </tr>
                        <tr>

                            <td className='bold'> Service Fee </td>
                            <td>{this.format_currancy(this.getAmountSum('cc_service_fee_amount'))} </td>
                        </tr>
                        <tr>

                            <td className='bold'> Total Amount </td>
                            <td>{this.format_currancy(this.getTotalAmount())} </td>
                        </tr>
                        <tr>
                            <td className='bold'> Description </td>
                            <td>{this.props.payment_description} </td>
                        </tr>
                        <tr>
                            <td colSpan='2'> <a className="sgl-hover" onClick={this.openViewRefundPolicyModal}>Click here</a> to view our refund policy. </td>
                        </tr>
                        {/* <tr>
                            <p>
                                <a className="sgl-hover" onClick={this.openViewRefundPolicyModal}>Click here</a> to view our refund policy.
                            </p>
                        </tr> */}
                        </tbody>
                    </table>
                    </>
                    :
                    <>
                    </>
                    }

                    <div className='entry_people_li'>
                        <div style={{clear: "both"}}></div>
                        <div style={{display:"inline-block",width: '50%'}} id="payment_method_bank" className='sgl-primary-header className-details, primary-header className-details-header add_entry_options'>
                            <input disabled={!this.props.ach_enabled || !this.props.can_checkout} checked={this.state.selected_payment_method_type === 'bank' && this.props.ach_enabled} style={{float: "left"}} type="radio" name='selected_payment_method_type' id='selected_payment_method_type_bank' value='bank' onChange={(e) => {this.onSelectedPaymentMethodType(e)}}/>
                            <label for="selected_payment_method_type_bank" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Bank Account</label>
                        </div>
                    </div>
                    {
                    (this.state.selected_payment_method_type == 'bank')?
                    <>
                    <table className="table payment_table">
                        <tbody>
                        <tr>
                            <td className='bold'> Bank Accounts </td>
                            <td>
                                <select id="credit_card" className="input-height select-width" value={this.state.selected_payment_method} onChange={(e) => this.onDepositMethodSelect(e)}>
                                    <option value="-1">Select Bank Account...</option>
                                    {
                                        this.props.bank_accounts.map((bank_account,index) => {
                                        return (
                                            <option value={`${bank_account.sgl_id}`} key={bank_account.sgl_id} data-type="bank">
                                                {bank_account.account_holder_name?`${bank_account.account_holder_name} - `:""}*{bank_account.last4} - {bank_account.bank_name}
                                            </option>
                                        )
                                        })
                                    }
                                    <option value='AddBankAccount'>Add Bank Account</option>
                                </select>
                            </td>
                        </tr>
                        <tr>

                            <td className='bold'> Amount </td>
                            <td>{this.format_currancy(this.getAmountSum('balance'))} </td>
                        </tr>
                        <tr>
                            <td className='bold'> ACH Service Fee </td>
                            <td>{this.format_currancy(this.getAmountSum('ach_service_fee_amount'))} </td>
                        </tr>
                        <tr>

                            <td className='bold'> Total Amount </td>
                            <td>{this.format_currancy(this.getTotalAmount())} </td>
                        </tr>
                        <tr>
                            <td className='bold'> Description </td>
                            <td>{this.props.payment_description} </td>
                        </tr>
                        <tr>
                            <td colSpan='2'> <a className="sgl-hover" onClick={this.openViewRefundPolicyModal}>Click here</a> to view our refund policy. </td>
                        </tr>
                        {/* <tr>
                            <p>
                                <a className="sgl-hover" onClick={this.openViewRefundPolicyModal}>Click here</a> to view our refund policy.
                            </p>
                        </tr> */}
                        </tbody>
                    </table>
                    </>
                    :
                    <></>
                    }
                </div>
                {/* <div id='payment_warning' className='required display_none'>{this.state.payment_error_msg}</div> */}
                <div id='payment_warning' className='required display_none' dangerouslySetInnerHTML={{ __html: this.state.payment_error_msg }}></div>

                <div className='continue-button-div'>
                    <input id='submit-payment-button' type="button" className='button sgl-button' value="Submit" onClick={this.saveCheckoutPayments()}/>
                    <span id="submit-please-wait" className='left display_none'><img src={indicator_icon} /> Processing...</span>

                </div>

                {(this.state.is_open_manage_card_modal) &&
                    <ManageCards 
                        payment_methods = {this.props.payment_methods} 
                        check_card_email_phone_info = {this.props.check_card_email_phone_info} 
                        check_address_info = {this.props.check_address_info}
                        is_open_manage_card_modal = {this.state.is_open_manage_card_modal}
                        closeManageCardModal = {this.closeSelectCardModal}
                        getPaymentMethods = {this.props.getPaymentMethods}
                        can_checkout = {this.props.can_checkout}
                        ref = {this.ManageCardsElement}
                        team_id = {this.context.currentTeamId != 'personal'?this.context.currentTeamId:0}
                    />
                }
                {(this.state.is_open_add_bank_modal) &&
                    <AddBankModal 
                        is_open_add_bank_modal = {this.state.is_open_add_bank_modal}
                        closeAddBankModal = {this.closeAddBankModal}
                        ref = {this.AddBankElement}
                    />
                }
                <div>
                    <AddModal
                    isOpen={this.state.is_open_view_policy_modal}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeViewRefundPolicyModal}
                    className="mymodal modal-width-responsive"
                    overlayClassName="myoverlay"
                    ariaHideApp={false}
                    // style={customStyles}
                    // contentLabel="Example Modal"
                    >

                        <h2>Refund Policy for {this.props.smc_payment.name}</h2>
                        <div>
                            <p>
                                {this.getRefundPolicy()}
                            </p>
                        </div>
                    
                        <div className='continue-button-div'>
                            <button className='right' onClick={this.closeViewRefundPolicyModal}>
                            Close
                            </button>
                        </div>
                    </AddModal>
                </div>
            </div>
            {/* <div id='payment_result' className='display_none'>
                {(this.state.payment_success) ? 
                    <p>Thank you! Payment has been submitted successfully.</p>
                :
                    <p>Transaction Declined: {this.state.payment_error_msg}</p>
                }
                <button className='sgl-button' onClick={this.backToCheckout()}>
                    Back to Checkout
                </button>

            </div> */}
          </div>
      
        );
    }
}

CheckoutPayment.contextType = SglContext;
export default CheckoutPayment;